import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import SweetAlert from 'react-bootstrap-sweetalert';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamation, faHeart, faTrash } from '@fortawesome/free-solid-svg-icons';
import TextArea from '../../components/TextArea';
import Loading from '../../components/Loading';
import api from '../../services/api';
import { Container, Table, ButtonPanel } from './styles';

import Button from '../../components/Button';
import Select from '../../components/Select';

export default class EvaluatePromoters extends Component {
  state = {
    advertences: [],
    alert: {},
    loading: true,
    promoters: [],
    showAlert: false,
  };

  static propTypes = {
    match: PropTypes.shape().isRequired,
    history: PropTypes.shape({
      push: PropTypes.func.isRequired,
    }).isRequired,
  };

  componentDidMount() {
    this.loadEvent();
  }

  loadEvent = async () => {
    const {
      match: {
        params: { id },
      },
      history: { push },
    } = this.props;
    try {
      const { data } = await api.get(`events/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token_producer')}`,
        },
      });

      const { status } = data.event;
      this.setState({ status });

      if (status !== 'pending_evaluation' && status !== 'finished') {
        push(`/panel/events/${id}`);
      } else {
        this.loadEventPromoters();
      }

      this.setState({ loading: false });
    } catch (err) {
      this.setState(
        {
          alert: {
            title: 'Erro',
            type: 'danger',
            messages: ['Não foi possível carregar o evento. Por favor, atualize a página.'],
            onConfirm: () => this.closeAlert(),
          },
        },
        () => {
          this.openAlert();
        },
      );
    }
  };

  loadEventPromoters = async () => {
    try {
      const { data } = await api.get('event_promoters', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token_producer')}`,
        },
        params: {
          event_id: this.props.match.params.id,
        },
      });

      const reviews = [];
      data.promoters.forEach((promoter) => {
        const evaluation = {};
        evaluation.promoter_id = promoter.id;
        evaluation.rating = promoter.advertences_count > 3 ? '1' : (5 - promoter.advertences_count).toString();
        evaluation.observation = '';
        reviews.push(evaluation);
      });
      this.setState({ promoters: data.promoters, reviews });
    } catch (err) {
      this.setState({ promoters: [] });
    }
  };

  viewAdvertences = (promoter_id) => {
    this.loadAdvertences(promoter_id);
    this.setState({
      currentPromoterId: promoter_id,
    });
  };

  loadAdvertences = async (promoter_id) => {
    try {
      const { data } = await api.get('advertences', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token_producer')}`,
        },
        params: {
          event_id: this.props.match.params.id,
          promoter_id,
        },
      });

      const formated = data.advertences.map(advertence => ({
        ...advertence,
        warned_at: moment(advertence.warned_at).format('DD/MM/YYYY, HH:mm[h]'),
      }));

      this.setState({
        advertences: formated,
      });
    } catch (err) {
      this.setState(
        {
          alert: {
            title: 'Erro',
            type: 'danger',
            messages: ['Não foi possível carregar as advertências. Por favor, atualize a página.'],
            onConfirm: () => this.closeAlert(),
          },
        },
        () => {
          this.openAlert();
        },
      );
    }
  };

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleChangeRating = (e, promoter_id) => {
    const { reviews } = this.state;
    const index = reviews.findIndex(x => x.promoter_id === promoter_id);
    reviews[index].rating = e.target.value;

    this.setState({ reviews });
  };

  handleChangeObservation = (e, promoter_id) => {
    const { reviews } = this.state;
    const index = reviews.findIndex(x => x.promoter_id === promoter_id);
    reviews[index].observation = e.target.value;

    this.setState({ reviews });
  };

  openAlert = () => {
    this.setState({
      showAlert: true,
    });
  };

  closeAlert = () => {
    this.setState({
      showAlert: false,
    });
  };

  addFavorite = async (id) => {
    const { promoters } = this.state;
    try {
      const formData = new FormData();
      formData.append('promoter_id', id);
      await api.post('favorite_promoters', formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token_producer')}`,
        },
      });

      const promoterIndex = promoters.findIndex(promoter => promoter.id === id);
      const updatedPromoters = promoters;
      updatedPromoters[promoterIndex].is_favorite = true;

      this.setState({
        promoters: updatedPromoters,
      });
    } catch (err) {
      this.setState(
        {
          alert: {
            title: 'Erro',
            type: 'danger',
            messages: ['Não foi possível favoritar o divulgador. Por favor, atualize a página.'],
            onConfirm: () => this.closeAlert(),
          },
        },
        () => {
          this.openAlert();
        },
      );
    }
  };

  deleteFavorite = async (id) => {
    const { promoters } = this.state;
    try {
      await api.delete(`favorite_promoters/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token_producer')}`,
        },
      });

      const promoterIndex = promoters.findIndex(promoter => promoter.id === id);
      const updatedPromoters = promoters;
      updatedPromoters[promoterIndex].is_favorite = false;

      this.setState({
        promoters: updatedPromoters,
      });
    } catch (err) {
      this.setState(
        {
          alert: {
            title: 'Erro',
            type: 'danger',
            messages: ['Não foi possível desfavoritar o divulgador. Por favor, atualize a página.'],
            onConfirm: () => this.closeAlert(),
          },
        },
        () => {
          this.openAlert();
        },
      );
    }
  };

  addAdvertence = async (e) => {
    e.preventDefault();

    try {
      const { advertenceReason, currentPromoterId } = this.state;
      const formData = new FormData();
      formData.append('reason', advertenceReason);
      formData.append('promoter_id', currentPromoterId);
      formData.append('event_id', this.props.match.params.id);
      await api.post('advertences', formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token_producer')}`,
        },
      });

      this.setState(
        {
          alert: {
            title: 'Advertência adicionada!',
            type: 'success',
            messages: ['A advertência foi adicionada com sucesso.'],
            onConfirm: () => this.closeAlert(),
          },
        },
        () => {
          this.openAlert();
          this.setState({
            advertenceReason: '',
          });
        },
      );

      document.getElementById('closeAdvertenceModal').click();
    } catch (err) {
      this.setState(
        {
          alert: {
            title: 'Erro',
            type: 'danger',
            messages: ['Não foi possível adicionar a advertência. Por favor, atualize a página.'],
            onConfirm: () => this.closeAlert(),
          },
        },
        () => {
          this.openAlert();
        },
      );
    }
  };

  deleteAdvertence = (id) => {
    this.setState(
      {
        alert: {
          title: 'Atenção',
          type: 'warning',
          messages: ['Tem certeza que deletar esta advertência?'],
          confirmBtnText: 'Deletar',
          confirmBtnBsStyle: 'danger',
          showCancel: true,
          cancelBtnText: 'Não',
          cancelBtnBsStyle: 'info',
          onConfirm: () => this.confirmDeleteAdvertence(id),
        },
      },
      () => {
        this.openAlert();
      },
    );
  };

  confirmDeleteAdvertence = async (id) => {
    const { advertences } = this.state;
    try {
      await api.delete(`advertences/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token_producer')}`,
        },
      });

      this.setState({ advertences: advertences.filter(advertence => advertence.id !== id) });
      this.closeAlert();
    } catch (err) {
      this.setState(
        {
          alert: {
            title: 'Erro',
            type: 'danger',
            messages: ['Não foi possível deletar a advertência. Por favor, atualize a página.'],
            onConfirm: () => this.closeAlert(),
          },
        },
        () => {
          this.openAlert();
        },
      );
    }
  };

  kickPromoter = (id) => {
    this.setState(
      {
        alert: {
          title: 'Atenção',
          type: 'warning',
          messages: ['Tem certeza que deseja excluir o divulgador do evento sem avaliá-lo?'],
          confirmBtnText: 'Excluir',
          confirmBtnBsStyle: 'danger',
          showCancel: true,
          cancelBtnText: 'Não',
          cancelBtnBsStyle: 'info',
          onConfirm: () => this.confirmKickPromoter(id),
        },
      },
      () => {
        this.openAlert();
      },
    );
  };

  confirmKickPromoter = async (id) => {
    const { promoters } = this.state;
    try {
      await api.delete(`event_promoters/${this.props.match.params.id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token_producer')}`,
        },
        params: {
          promoter_id: id,
        },
      });

      this.setState({ promoters: promoters.filter(promoter => promoter.id !== id) });
      this.closeAlert();
    } catch (err) {
      this.setState(
        {
          alert: {
            title: 'Erro',
            type: 'danger',
            messages: ['Não foi possível expulsar o divulgador. Por favor, atualize a página.'],
            onConfirm: () => this.closeAlert(),
          },
        },
        () => {
          this.openAlert();
        },
      );
    }
  };

  submitReviews = () => {
    this.setState(
      {
        alert: {
          title: 'Tem certeza?',
          type: 'warning',
          messages: ['As notas não poderão ser alteradas posteriormente.'],
          confirmBtnText: 'Enviar',
          confirmBtnBsStyle: 'success',
          showCancel: true,
          cancelBtnText: 'Cancelar',
          cancelBtnBsStyle: 'info',
          onConfirm: () => this.confirmSubmitReviews(),
        },
      },
      () => {
        this.openAlert();
      },
    );
  };

  confirmSubmitReviews = async () => {
    const { reviews } = this.state;
    const {
      match: {
        params: { id },
      },
      history: { push },
    } = this.props;

    try {
      await api.post(
        'reviews',
        {
          event_id: this.props.match.params.id,
          reviews,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token_producer')}`,
          },
        },
      );
      this.setState({
        alert: {
          title: 'Divulgadores avaliados!',
          type: 'success',
          messages: ['Os divulgadores foram avaliados com sucesso.'],
          onConfirm: () => push(`/panel/events/${id}`),
        },
        showAlert: true,
      });
    } catch (err) {
      this.setState({
        alert: {
          title: 'Erro',
          type: 'danger',
          messages: err.response.data.errors,
          onConfirm: () => this.closeAlert(),
          showAlert: true,
        },
      });
    }
  };

  render() {
    const {
      advertences,
      advertenceReason,
      alert: {
        cancelBtnText,
        cancelBtnBsStyle,
        confirmBtnText,
        confirmBtnBsStyle,
        messages,
        onConfirm,
        showCancel,
        title,
        type,
      },
      loading,
      promoters,
      reviews,
      showAlert,
      status,
    } = this.state;

    return (
      <Fragment>
        {loading ? (
          <Loading />
        ) : (
          <Container>
            <h1 className="page-title">
              {status === 'pending_evaluation' ? 'Avaliação dos divulgadores' : 'Divulgadores'}
            </h1>
            <div className="box">
              <div className="row">
                <div className="col-12">
                  {status === 'pending_evaluation' && (
                    <ButtonPanel>
                      <button
                        type="button"
                        onClick={this.submitReviews}
                        className="btn btn-success align-right"
                      >
                        Enviar avaliação
                      </button>
                    </ButtonPanel>
                  )}
                  {promoters.length > 0 ? (
                    <div className="table-wrapper">
                      <Table className="table">
                        <thead>
                          <tr>
                            <th scope="col">Foto</th>
                            <th scope="col">Nome</th>
                            <th scope="col">Instagram</th>
                            <th scope="col">
                              {status === 'pending_evaluation' ? 'Opções' : 'Favoritar'}
                            </th>
                            {status === 'pending_evaluation' && (
                              <Fragment>
                                <th scope="col">Advertências</th>
                                <th scope="col">Nota</th>
                                <th scope="col">Observações</th>
                              </Fragment>
                            )}
                          </tr>
                        </thead>
                        <tbody>
                          {promoters.map(promoter => (
                            <tr key={promoter.id}>
                              <th scope="row">
                                <div
                                  className="profile-image"
                                  style={
                                    promoter.avatar.url && {
                                      backgroundImage: `url(${promoter.avatar.url})`,
                                    }
                                  }
                                />
                              </th>
                              <td>{promoter.name}</td>
                              <td>
                                <a
                                  href={`http://instagram.com/${promoter.instagram_username}`}
                                  target="blank"
                                >
                                  @{promoter.instagram_username}
                                </a>
                              </td>
                              <td>
                                {promoter.is_favorite ? (
                                  <Button
                                    onClick={() => this.deleteFavorite(promoter.id)}
                                    className="btn-success btn-small"
                                  >
                                    <FontAwesomeIcon icon={faHeart} />
                                  </Button>
                                ) : (
                                  <Button
                                    onClick={() => this.addFavorite(promoter.id)}
                                    className="btn-light btn-small"
                                  >
                                    <FontAwesomeIcon icon={faHeart} />
                                  </Button>
                                )}
                                {status === 'pending_evaluation' && (
                                  <Button
                                    onClick={() => this.kickPromoter(promoter.id)}
                                    className="btn-dark btn-small"
                                  >
                                    <FontAwesomeIcon icon={faTrash} />
                                  </Button>
                                )}
                              </td>
                              {status === 'pending_evaluation' && (
                                <Fragment>
                                  <td>
                                    <button
                                      onClick={() => this.viewAdvertences(promoter.id)}
                                      type="button"
                                      className={`btn ${
                                        promoter.advertences_count > 0
                                          ? 'btn-danger'
                                          : 'btn-secondary'
                                      } btn-small`}
                                      data-toggle="modal"
                                      data-target="#viewAdvertences"
                                    >
                                      <FontAwesomeIcon icon={faExclamation} />
                                    </button>
                                  </td>
                                  <td>
                                    <Select
                                      value={
                                        reviews.filter(r => r.promoter_id === promoter.id)[0].rating
                                      }
                                      onChange={e => this.handleChangeRating(e, promoter.id)}
                                      options={[
                                        { value: '1', text: '1' },
                                        { value: '2', text: '2' },
                                        { value: '3', text: '3' },
                                        { value: '4', text: '4' },
                                        { value: '5', text: '5' },
                                      ]}
                                    />
                                  </td>
                                  <td>
                                    <TextArea
                                      value={
                                        reviews.filter(r => r.promoter_id === promoter.id)[0]
                                          .observation
                                      }
                                      onChange={e => this.handleChangeObservation(e, promoter.id)}
                                      placeholder="Observações"
                                    />
                                  </td>
                                </Fragment>
                              )}
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  ) : (
                    <h5 className="text-center">Este evento não possui divulgadores ativos.</h5>
                  )}
                </div>
              </div>
            </div>

            {showAlert && (
              <SweetAlert
                type={type}
                confirmBtnText={confirmBtnText}
                confirmBtnBsStyle={confirmBtnBsStyle}
                showCancel={showCancel}
                cancelBtnText={cancelBtnText}
                cancelBtnBsStyle={cancelBtnBsStyle}
                title={title}
                onConfirm={onConfirm}
                onCancel={this.closeAlert}
              >
                <ul>
                  {messages.map(msg => (
                    <li key={msg}>{msg}</li>
                  ))}
                </ul>
              </SweetAlert>
            )}

            <div
              className="modal fade"
              id="viewAdvertences"
              tabIndex="-1"
              role="dialog"
              aria-labelledby="viewAdvertencesLabel"
              aria-hidden="true"
            >
              <div className="modal-dialog" role="document" style={{ maxWidth: '800px' }}>
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title" id="viewAdvertencesLabel">
                      Advertências
                    </h5>
                    <button
                      id="closeAdvertenceModal"
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <h5>Adicionar advertência:</h5>
                    <form onSubmit={this.addAdvertence}>
                      <div className="input-group">
                        <TextArea
                          onChange={this.handleChange}
                          value={advertenceReason}
                          name="advertenceReason"
                          className="form-control"
                          placeholder="Motivo"
                        />
                        <button className="btn btn-primary send-advertence" type="submit">
                          Enviar
                        </button>
                      </div>
                    </form>
                    <hr />
                    <h5>Advertências existentes:</h5>
                    {advertences.length > 0 ? (
                      <div className="table-wrapper">
                        <Table className="table">
                          <thead>
                            <tr>
                              <th>Data</th>
                              <th>Advertido por</th>
                              <th>Motivo</th>
                              <th>Excluir advertência</th>
                            </tr>
                          </thead>
                          <tbody>
                            {advertences.map(advertence => (
                              <tr key={advertence.id}>
                                <th scope="row">{advertence.warned_at}</th>
                                <td>{advertence.producer_name}</td>
                                <td>{advertence.reason}</td>
                                <td>
                                  <Button
                                    onClick={() => this.deleteAdvertence(advertence.id)}
                                    className="btn-outline-danger btn-small"
                                  >
                                    Excluir
                                  </Button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>
                    ) : (
                      <p className="text-center">Divulgador não possui advertências neste evento.</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </Container>
        )}
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/EvaluatePromoters/index.js